const WHO_AM_I_QUERY_KEY = 'whoAmI';

export { WHO_AM_I_QUERY_KEY };
